import { Pipe, PipeTransform } from '@angular/core';
import { map } from 'rxjs/operators';
import _ from 'lodash';
import { Store } from '@ngxs/store';
import { BrickInstancesSelectors } from '../../store/dashboard/brick-wall/brick-instances/brick-instances.selectors';
import { IBrickDescription } from 'src/app/store/dashboard/brick-wall/brick-instances/brick-instances.state';
import { Observable } from 'rxjs';

@Pipe({
   name: 'instanceIdToBrickDescription$',
})
export class InstanceIdToBrickDescriptionPipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(brickInstanceId: string): Observable<IBrickDescription> {
      return this.store.select(BrickInstancesSelectors.brickDescriptionFn).pipe(map((fn) => fn(brickInstanceId)));
   }
}
